import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from 'ng2-bootstrap-modal';
import { Observable } from 'rxjs/Rx';
import { SMSURLLABELS } from '../_constants/constants';
import { SmsURLService } from '../_services/smsurl.service';
import { NotificationDialogComponent } from './../notification/notification.dialog.component';

@Component({
  templateUrl: './smsurl.component.html',
  providers: [ SmsURLService ]
})

export class SmsurlComponent implements OnInit{
  smsurllabels = SMSURLLABELS;
  tokenID = '';
  pinCode = '';
  isValid = true;
  smsurlService: SmsURLService;

  constructor(private router: Router, private ds: DialogService, private route: ActivatedRoute, smsurlService: SmsURLService) {
    this.smsurlService= smsurlService;
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.tokenID = params['tokenId'];
      this.pinCode = params['pincode'];
    });
    console.log("Token ID: " + this.tokenID);
    console.log("Pincode: " + this.pinCode);
  }

  verifyOTPRequest() {
    this.isValid = false;
    this.smsurlService.verifyOTP(this.tokenID, this.pinCode, this.ds);
  }

  cancelOTPRequest() {
     this.router.navigate(['/smsurl']);
  }
}



// WEBPACK FOOTER //
// ./src/app/smsurl/smsurl.component.ts